'use client';
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["as", "classPrefix", "className", "inverse", "backdrop", "speed", "center", "vertical", "content", "size"];
import React from 'react';
import PropTypes from 'prop-types';
import { useClassNames, useUniqueId } from "../internals/hooks/index.js";
import { oneOf } from "../internals/propTypes/index.js";
/**
 * The `Loader` component is used to indicate the loading state of a page or a section.
 * @see https://rsuitejs.com/components/loader
 */
var Loader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$as = props.as,
    Component = _props$as === void 0 ? 'div' : _props$as,
    _props$classPrefix = props.classPrefix,
    classPrefix = _props$classPrefix === void 0 ? 'loader' : _props$classPrefix,
    className = props.className,
    inverse = props.inverse,
    backdrop = props.backdrop,
    _props$speed = props.speed,
    speed = _props$speed === void 0 ? 'normal' : _props$speed,
    center = props.center,
    vertical = props.vertical,
    content = props.content,
    size = props.size,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _useClassNames = useClassNames(classPrefix),
    merge = _useClassNames.merge,
    withClassPrefix = _useClassNames.withClassPrefix,
    prefix = _useClassNames.prefix;
  var labelId = useUniqueId('loader-label-');
  var classes = merge(className, prefix('wrapper', "speed-" + speed, size, {
    'backdrop-wrapper': backdrop,
    vertical: vertical,
    inverse: inverse,
    center: center
  }));
  return /*#__PURE__*/React.createElement(Component, _extends({
    role: "status",
    "aria-labelledby": content ? labelId : undefined
  }, rest, {
    ref: ref,
    className: classes
  }), backdrop && /*#__PURE__*/React.createElement("div", {
    className: prefix('backdrop')
  }), /*#__PURE__*/React.createElement("div", {
    className: withClassPrefix()
  }, /*#__PURE__*/React.createElement("span", {
    className: prefix('spin')
  }), content && /*#__PURE__*/React.createElement("span", {
    id: labelId,
    className: prefix('content')
  }, content)));
});
Loader.displayName = 'Loader';
Loader.propTypes = {
  as: PropTypes.elementType,
  className: PropTypes.string,
  classPrefix: PropTypes.string,
  center: PropTypes.bool,
  backdrop: PropTypes.bool,
  inverse: PropTypes.bool,
  vertical: PropTypes.bool,
  content: PropTypes.node,
  size: oneOf(['lg', 'md', 'sm', 'xs']),
  speed: oneOf(['normal', 'fast', 'slow', 'paused'])
};
export default Loader;